"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dentalQuoteComparison_enDe = void 0;
exports.dentalQuoteComparison_enDe = {
    metaData: {
        prismicId: 'ZuveJhIAACsAYQm-',
        type: 'comparisontable',
        uid: 'dental-quote-comparison',
        lang: 'en-de',
        lastPublished: '2024-09-30T12:16:55+0000',
    },
    tableData: {
        title: 'Dental quote',
        collapsibleSections: false,
        hideDetails: false,
        tableData: [
            {
                section: {
                    title: '',
                },
                rows: [
                    [
                        {
                            cellId: 'table_row$50e94fcb-b761-4784-aabc-be44207b8a59_header',
                            text: 'Choose a plan',
                            description: null,
                        },
                        {
                            cellId: 'table_row$50e94fcb-b761-4784-aabc-be44207b8a59_0',
                            type: 'BUTTON',
                            buttonCaption: 'Basic',
                            disabled: true,
                        },
                        {
                            cellId: 'table_row$50e94fcb-b761-4784-aabc-be44207b8a59_1',
                            type: 'BUTTON',
                            buttonCaption: 'Advanced',
                            disabled: true,
                        },
                        {
                            cellId: 'table_row$50e94fcb-b761-4784-aabc-be44207b8a59_2',
                            type: 'BUTTON',
                            buttonCaption: 'Public health',
                            disabled: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$d412b126-9401-4712-b7d5-e2b90a1afe26_header',
                            text: 'No waiting periods',
                            description: null,
                            modalContent: 'Once you sign up for dental insurance, your application will be processed and approved within 1-3 business days. After that, you can immediately start using your full benefits at the dentist. \n\nJust keep in mind that any procedures for which you had an appointment or planned before applying for dental insurance won’t be covered.',
                        },
                        {
                            cellId: 'table_row$d412b126-9401-4712-b7d5-e2b90a1afe26_0',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$d412b126-9401-4712-b7d5-e2b90a1afe26_1',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$d412b126-9401-4712-b7d5-e2b90a1afe26_2',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$8de3317f-3db2-42ba-89cc-298a519f18a9_header',
                            text: 'Professional dental cleaning',
                            description: null,
                            modalContent: '**How often do I need dental cleanings?**\n\nMany dentists recommend having a dental cleaning every six months.\n\n**How much does it cost?**\n\nThe cost of a standard dental cleaning in Germany typically ranges from €60 to €120.',
                        },
                        {
                            cellId: 'table_row$8de3317f-3db2-42ba-89cc-298a519f18a9_0',
                            text: '€150/year',
                        },
                        {
                            cellId: 'table_row$8de3317f-3db2-42ba-89cc-298a519f18a9_1',
                            text: '€200/year',
                            description: '20% co-pay applies',
                            modalContent: '**How does it work?**\n\nIf you submit a dental cleaning claim for €120, you will cover €24, and we will cover the remaining €96. You can submit as many dental cleanings per year as needed, up to a total reimbursement limit of €200.',
                        },
                        {
                            cellId: 'table_row$8de3317f-3db2-42ba-89cc-298a519f18a9_2',
                            text: 'up to €50/year',
                            description: 'varies by provider',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$7820e5ee-259d-45bf-9224-b865e6fe3fa0_header',
                            text: 'Dental treatments',
                            description: 'E.g. high quality fillings, root canal treatments, mouth guards, pain relief treatments',
                        },
                        {
                            cellId: 'table_row$7820e5ee-259d-45bf-9224-b865e6fe3fa0_0',
                            description: 'limits apply',
                            modalContent: 'Combined limit (total) for dental treatments:\n\n**First year:** €150 \n\n**Second year:** €150\n\n**After 2 years:** No limits\n\n\n\n**Do limits carry over?**\n\nYes, if you submit a €50 claim and get reimbursed in the first year, the remaining €100 will carry over to the second year, giving you a limit of €250 for the second year.\n\n\n\n**What type of treatments fall within these limits?**\n\n- High quality fillings\n\n- Root canal and periodontitis treatments \n\n- Mouthguard/bite guards \n\n- Pain relief treatments\n\nThese limits do not apply in case of reconstructive work after an accident.',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$7820e5ee-259d-45bf-9224-b865e6fe3fa0_1',
                            description: 'limits apply',
                            modalContent: 'Combined limit (total) for dental treatments:\n\n**First year:** €150 \n\n**Second year:** €150\n\n**After 2 years:** No limits\n\n\n**Do limits carry over?**\n\nYes, if you submit a €50 claim and get reimbursed in the first year, the remaining €100 will carry over to the second year, giving you a limit of €250 for the second year.\n\n\n**What type of treatments fall within these limits?**\n\n- High quality fillings\n\n- Root canal and periodontitis treatments \n\n- Mouthguard/bite guards \n\n- Pain relief treatments\n\nThese limits do not apply in case of reconstructive work after an accident.',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$7820e5ee-259d-45bf-9224-b865e6fe3fa0_2',
                            text: 'Only basic care',
                            modalContent: 'Public health insurance only provides basic care-level (Grundvorsorge) treatments.\n\n- **Fillings:** coverage only for amalgam fillings, which has a metallic silver color. High-quality composite fillings are not covered.\n\n- **Root canal treatments:** covered if it is medically necessary and can preserve the tooth.\n\n- **Pain relief treatments**',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$c030be62-bd39-4dad-8ff9-956a6949a63e_header',
                            text: 'Tooth replacement',
                            description: 'E.g. implants, bridges. crowns, inlays',
                            modalContent: '**When do I need a tooth replacement?**\nThe most common reason is significant damage or loss of one or more teeth, which can’t be treated by fillings. This can result from factors such as decay, gum disease, trauma, or injury.\n\n**What are the treatments covered under tooth replacement procedures?**\n**•** Crowns\n\n**•** Implants\n\n**•** Dental bridges\n\n**•** Inlays and onlays\n\n**How much does it cost?**\n\nTooth replacement procedures can be quite expensive, ranging from €1,000 for a crown to €3,000 for an implant.',
                        },
                        {
                            cellId: 'table_row$c030be62-bd39-4dad-8ff9-956a6949a63e_0',
                            description: 'only what’s covered by public health',
                            modalContent: 'The basic plan only includes the base-care-level coverage provided by public health insurance. It does not offer extra coverage for tooth replacement procedures.',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$c030be62-bd39-4dad-8ff9-956a6949a63e_1',
                            text: '80 - 100%',
                            description: 'Select the amount below.\nLimits apply',
                            modalContent: 'The advanced plan will top up the public insurance coverage and protect you against high costs for tooth replacement procedures.\n\n&nbsp;\n\n**How many missing teeth do you currently have?**\n\nIf you lose teeth after signing up, this does not affect your limits.\n\n&nbsp;\n\n| Years on policy | 0-1 tooth missing | 2 teeth missing | 3 teeth missing |\n| - | - | - | - |\n| 1 year | €1,500 | €250 | €125 |\n| 2 years | €1,500 | €250 | €125 |\n| 3 years | €1,500 | €250 | €125 |\n| 4 years | €1,500 | €5,250 | €5,625 |\n| 5+ years | No limits | No limits | No limits |\n\n&nbsp;\n\n**What counts as missing teeth?**\n\nAny adult teeth that have not been replaced through an implant or another tooth replacement procedure. Wisdom teeth are not considered as missing teeth.\n\n&nbsp;\n\n**Do limits carry over?**\n\nYes, any unused yearly limit will be carried over to the next year. \n\nThese limits do not apply in case of reconstructive work after an accident.',
                        },
                        {
                            cellId: 'table_row$c030be62-bd39-4dad-8ff9-956a6949a63e_2',
                            text: 'Up to 60%',
                            description: 'basic-care limits',
                            modalContent: "Public health insurance covers up to 60% of basic care-level (Grundvorsorge) treatments for tooth replacements. This includes amalgam, which has a metallic silver color and may cause sensitivity to hot and cold.\n\nIf you choose composite replacements that last longer and match your tooth color, they won't be covered by public health insurance.",
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$bad32dd5-ef83-49c5-a07b-7dc03a047d73_header',
                            text: 'Tooth & jaw alignment',
                            description: 'E.g. braces, aligners',
                        },
                        {
                            cellId: 'table_row$bad32dd5-ef83-49c5-a07b-7dc03a047d73_0',
                            description: 'limits apply',
                            modalContent: 'Dental insurance - both basic and advanced plans - adds up to €2,000 to public health coverage for **treatments starting before turning 21.**\n\n&nbsp;\n\n**Limits**\n\nFirst year: €150 \n\nSecond year: €150\n\nAfter 2 years: €1,700\n\n&nbsp;\n\n**Do limits carry over?**\n\nYes, if you get reimbursed for €150 in the first year and do not use any funds in the second year, the remaining €150 will be carried over, giving you a total limit of €1,850 for jaw alignment treatments after 2 years.\n\nThese limits do not apply in case of reconstructive work after an accident.',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$bad32dd5-ef83-49c5-a07b-7dc03a047d73_1',
                            description: 'limits apply',
                            modalContent: 'Dental insurance - both basic and advanced plans - adds up to €2,000 to public health coverage for **treatments starting before turning 21.**\n\n&nbsp;\n\n**Limits**\n\nFirst year: €150 \n\nSecond year: €150\n\nAfter 2 years: €1,700\n\n&nbsp;\n\n**Do limits carry over?**\n\nYes, if you get reimbursed for €150 in the first year and do not use any funds in the second year, the remaining €150 will be carried over, giving you a total limit of €1,850 for jaw alignment treatments after 2 years.\n\nThese limits do not apply in case of reconstructive work after an accident.',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$bad32dd5-ef83-49c5-a07b-7dc03a047d73_2',
                            description: 'limits apply',
                            modalContent: 'Public health insurance covers medically necessary treatments with severity level 3 (KIG 3) or higher for individuals under 18 years old.\n\n&nbsp;\n\n**How does the severity level determined?**\n\nThe orthodontist assesses the medical necessity of the treatment using 5 severity levels, known as orthodontic indication groups (KIG).',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$6aab0295-a26d-428d-83f5-eb9449d47626_header',
                            text: 'Teeth whitening',
                            description: null,
                        },
                        {
                            cellId: 'table_row$6aab0295-a26d-428d-83f5-eb9449d47626_0',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$6aab0295-a26d-428d-83f5-eb9449d47626_1',
                            text: '€200',
                            description: 'per every 2 years',
                        },
                        {
                            cellId: 'table_row$6aab0295-a26d-428d-83f5-eb9449d47626_2',
                            checkmarkValue: false,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$9d40445b-5b26-4a82-89e2-80bcfffff3f6_header',
                            text: 'Purely cosmetic procedures',
                            description: null,
                        },
                        {
                            cellId: 'table_row$9d40445b-5b26-4a82-89e2-80bcfffff3f6_0',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$9d40445b-5b26-4a82-89e2-80bcfffff3f6_1',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$9d40445b-5b26-4a82-89e2-80bcfffff3f6_2',
                            checkmarkValue: false,
                        },
                    ],
                ],
            },
        ],
    },
};
